import { i18n } from "translate/i18n";

export const title = i18n.t("titles.planCreation.title");
export const subtitle = i18n.t("titles.planCreation.subtitle");
export const createNow = i18n.t("messages.planCreation.formTitle");
